import { useRef, useState } from 'react';

const PAGE_SIZE = 10;
const useGetUsers = () => {
  const pageNumber = useRef(1);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        'https://mock.apidog.com/m1/798496-777122-default/workDirectionUsers',
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const { data } = await response.json();
      setUsers(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const loadMoreData = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    // Simula una llamada a una API
    fetch(
      `https://mock.apidog.com/m1/798496-777122-default/workDirectionUsers?pageNumber=${pageNumber.current}&pageSize=${PAGE_SIZE}`,
    )
      .then(response => response.json())
      .then(newData => {
        const newUsers = newData.data || [];
        setUsers(prevData => [...prevData, ...newUsers]);
        pageNumber.current += 1;
        setLoading(false);
        if (newUsers.length === 0) {
          setHasMore(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return { users, loading, error, fetchUsers, loadMoreData, hasMore };
};

export default useGetUsers;
